import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export type EcChargeStatus = "PENDING" | "INVOICED" | "PAID" | "OVERDUE" | "FALLBACK_TRANSFERRED" | "WAIVED";
export type EcCollectionMode = "DIRECT_FROM_CUSTOMER" | "VIA_TENANT" | "DIRECT_WITH_TENANT_FALLBACK";

export interface EcCharge {
  id                  : string;
  tenantId            : string;
  endCustomerBusinessId: string;
  componentId         : string;
  period              : string;
  amount              : string;
  currency            : string;
  collectionMode      : EcCollectionMode;
  status              : EcChargeStatus;
  invoiceId           : string | null;
  dueDate             : string;
  paidAt              : string | null;
  transferredToTenantAt: string | null;
  idempotencyKey      : string;
  createdAt           : string;
  updatedAt           : string;
}

export interface ChargeListParams {
  tenantId?: string;
  customerBusinessId?: string;
  period?: string;
  status?: EcChargeStatus;
  page?: number;
  limit?: number;
}

export const listMy = (params?: ChargeListParams) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  httpRequest.get("/bil/my/ec-charges", params as any);

export const listAdmin = (params?: ChargeListParams) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  httpRequest.get("/bil/admin/ec-charges", params as any);

export const markPaid = (id: string, body: { externalPaymentId?: string; paidAt?: string }) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  httpRequest.post(`/bil/admin/ec-charges/${id}/mark-paid`, body as any);

export const waive = (id: string, body: { reason: string }) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  httpRequest.post(`/bil/admin/ec-charges/${id}/waive`, body as any);

export const runBilling = (body: { period: string; dryRun?: boolean }) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  httpRequest.post("/bil/admin/ec/run-billing", body as any);
